import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Spinner } from '../ui/spinner';
import { useState } from 'react';
import { useToast } from '../ui/use-toast';
import Image from 'next/image';
import Link from 'next/link';
import SmartImage from '../SmartImage';

export default function MasterpassConnectDialog({
  open,
  phone,
  isConnecting,
  onOpenChange,
  connectHandler,
  rejectHandler,
}: {
  open: boolean;
  phone: string | undefined;
  isConnecting: boolean;
  onOpenChange: (open: boolean) => void;
  connectHandler: () => void;
  rejectHandler: () => void;
}) {
  const { toast } = useToast();

  const [code, setCode] = useState('');

  const aError = () => {
    toast({
      variant: 'destructive',
      description: 'Bir hata oluştu',
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[425px]"
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="space-y-0">
          <div className="mb-5 text-center">
            <SmartImage
              className="inline"
              src="/masterpass.svg"
              alt="masterpass by mastercard"
              width={149}
              height={32}
              imageType="custom"
            />
          </div>
          <DialogTitle className="text-[32px] text-hzc_purple_500">
            Masterpass Hesabınız Bulundu!
          </DialogTitle>
          <DialogDescription className="h-0"></DialogDescription>
        </DialogHeader>
        <div>
          &lt;+90{String(phone || '').slice(-10)}&gt; telefon numarası ile oluşturulan Masterpass
          hesabınızdaki kayıtlı kartlarınızı görüntülemek ister misiniz?
        </div>
        <div>
          <Link
            href="https://www.mastercard.com.tr/tr-tr/tuketiciler/odeme-secenekleri/masterpass.html"
            target="_blank"
            className="underline"
          >
            Masterpass nedir?
          </Link>
        </div>
        <DialogFooter className="gap-2">
          <div className="flex flex-row gap-4 justify-end">
            <Button
              className="text-hzc_beige_900 border-0 border-[#FFFFFF] bg-[#FFFFFF] hover:bg-[#FFFFFF] rounded-full h-[48px] focus-visible:ring-0 focus-visible:ring-offset-0"
              onClick={() => rejectHandler()}
            >
              Hayır istemiyorum
            </Button>
            <Button
              className="text-white bg-[#05B050] hover:bg-[#05B050] transition-all duration-300 hover:scale-105 rounded-full h-[48px] gap-2"
              onClick={() => connectHandler()}
            >
              {isConnecting && <Spinner className="size-6 text-white" />}
              Evet isterim
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
